module.exports = __webpack_public_path__ + "static/media/admin_active.e66ec214.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/admin_active.svg
// module id = 1089
// module chunks = 36